import { IUserSession } from '../../../helpers/user-session'
import { LoggerService } from '../../common/common.module'
import { IssueCreateEditController } from './issues-create-edit.directive.controller'
import { IssueHelper } from '../issues.helper'

//#region Asset Imports

import './issues-create-edit.scss'
import * as TEMPLATE from './issues-create-edit.tpl.html'

//#endregion

// Setup

export class IssueCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger',  'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            logger: LoggerService,
            userSession: IUserSession
        ) => new IssueCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            logger, 
            userSession,
            IssueHelper.REFERENCE_TYPE,
            IssueHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// Setup End